<template>
  <div class="wrapper">
    <!--搜索-->
    <div class="search-wrapper" v-loading="loading">
      <el-form
        :inline="true"
        size="mini"
        label-width="80px"
        :model="searchForm"
        ref="serachBox"
        :style="{ height: formHeight,overflow: 'hidden'}"
      >
        <div style="float: right; margin-top: 2px; margin-left: 20px">
          <el-link
            type="primary"
            :underline="false"
            @click="onCollapse"
            style="margin-right: 15px"
            v-if="activeName == 'store'"
            >{{ formHeight == "30px" ? "展开" : "折叠" }}</el-link
          >
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
        </div>
        <div class="search-row">
          <el-form-item label="店铺" v-if="activeName == 'store' || activeName == 'messageNotification'">
            <el-select v-model="searchForm.storeCode" placeholder="请选择" @change="stroeChange" key="store">
            <el-option
              v-for="item in storeList"
              :key="item.storeCode"
              :label="item.storeName"
              :value="item.storeCode">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="清仓批次" v-if="activeName == 'wholeNetwork' || activeName == 'store'">
            <el-select v-model="searchForm.batchNameList" placeholder="请选择" clearable multiple collapse-tags @change="onSearch">
            <el-option
              v-for="(item,index) in batchNameList"
              :key="index"
              :label="item.batchName"
              :value="item.batchName">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="商品编码" v-if="activeName != 'wholeNetwork' && activeName != 'messageNotification'">
            <el-input v-model="searchForm.goodsCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="商品名称" v-if="activeName != 'wholeNetwork' && activeName != 'messageNotification'">
            <el-input v-model.trim="searchForm.goodsName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="清仓开始时间" label-width="110px" v-if="activeName != 'modifyLog' && activeName != 'messageNotification'">
            <el-date-picker
              class="date-input"
              size="mini" 
              v-model="searchForm.date"
              value-format="yyyyMMdd"
              type="daterange" 
              range-separator="-" 
              start-placeholder="开始日期" 
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" v-if="activeName == 'store'">
            <el-radio-group v-model="searchForm.clearanceStatus">
            <el-radio label="">全部</el-radio>
            <el-radio label="清仓在售">清仓在售</el-radio>
            <el-radio label="清仓停销">清仓停销</el-radio>
          </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="tabsBox">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="loading" v-if="!loading">
        <el-tab-pane label="全网" name="wholeNetwork" v-if="isFullPlatform">
          <whole-network 
            ref="wholeNetwork"
            v-if="activeName == 'wholeNetwork'"
            v-model="searchForm"
            :formHeight="formHeight"
            :storeList="storeList"
            @getBatchNameList="getBatchNameList"
          />
        </el-tab-pane>
        <el-tab-pane label="店铺" name="store">
          <store 
            ref="store"
            v-if="activeName == 'store'"
            v-model="searchForm"
            :formHeight="formHeight"
            :storeList="storeList"
            :isFullPlatform="isFullPlatform"
            @stroeChange="stroeChange"
            @getBatchNameList="getBatchNameList"
          />
        </el-tab-pane>
        <el-tab-pane  name="modifyLog" v-if="isFullPlatform">
          <span slot="label">
            修改日志
            <el-badge value='新' :hidden="!isFlag.newLogFlag"></el-badge>
          </span>
          <modify-log
            ref="modifyLog"
            v-if="activeName == 'modifyLog'"
            v-model="searchForm"
            :formHeight="formHeight"
            :storeList="storeList"
            @messageStatus="messageStatus"
          />
        </el-tab-pane>
        <el-tab-pane name="messageNotification" v-if="!isFullPlatform">
          <span slot="label">
            消息通知
            <el-badge value='新' :hidden="!isFlag.newMessageFlag"></el-badge>
          </span>
          <message-notification
            ref="messageNotification"
            v-if="activeName == 'messageNotification'"
            v-model="searchForm"
            :formHeight="formHeight"
            :storeList="storeList"
            @stroeChange="stroeChange"
            @messageStatus="messageStatus"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import wholeNetwork from "./wholeNetwork/wholeNetwork.vue";
import store from "./store/store.vue";
import modifyLog from "./modifyLog/modifyLog.vue";
import messageNotification from "./messageNotification/messageNotification.vue";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "WarehouseCearanceManagement",
  mixins: [pagePathMixin],
  components: {
    wholeNetwork,
    store,
    modifyLog,
    messageNotification,
  },
  data() {
    return {
      formHeight: '30px',
      activeName: "",
      isShowExpand: false,
      searchForm: {
        clearanceStatus: '清仓在售',
      },
      storeList: [],
      isFullPlatform: false,
      isFlag: {},
      loading: false,
      batchNameList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {
    activeNameComponent() {
      return this.activeName;
    },
  },
  mounted() {
    this.checkShowExpand()
    this.getUserStoreList()
  },
  methods: {
    handleClick() {
      this.searchForm = {
        storeCode: this.searchForm.storeCode
      }
      this.$set(this.searchForm,'clearanceStatus','清仓在售')
      this.checkShowExpand()
    },
    onSearch() {
      this.$refs[this.activeName].onSearch()
    },
    onReset() {
      this.$refs[this.activeName].reset()
    },
    onCollapse() {
      if (this.formHeight === "30px") {
        this.formHeight = "auto";
      } else {
        this.formHeight = "30px";
      }
    },
    stroeChange() {
      this.loading = true
      this.isFullPlatform = this.searchForm.storeCode == 0
      this.$nextTick(() => {
        this.loading = false
        this.activeName = this.isFullPlatform ? "wholeNetwork" : 'store'
      })
      this.messageStatus()
    },
    checkShowExpand() {
      this.$nextTick(()=>{
        this.isShowExpand = this.$refs.serachBox.$el.scrollHeight > 39
        && this.$refs.serachBox.$el.scrollWidth > document.documentElement.clientWidth - 252 ;
      })
    },
    //获取用户店铺权限下拉
    getUserStoreList() {
      this.loading = true
      this.$q.clearanceManagement.userStoreList().then(res => {
        if(res.data && res.data.length) {
          this.storeList = res.data
          this.$set(this.searchForm,'storeCode',res.data[0].storeCode)
          this.isFullPlatform = this.searchForm.storeCode == 0
          this.activeName = this.isFullPlatform ? "wholeNetwork" : 'store'
          this.messageStatus()
        }else {
           this.storeList = []
        }
      }).finally(()=> {
        this.loading = false
      })
    },
    //新 标识是否展示获取
    messageStatus() {
      const params = {
        fragment: [this.searchForm.storeCode]
      };
      this.$q.clearanceManagement.messageStatus(params).then(res => {
        let { newLogFlag, newMessageFlag } = res.data
        this.isFlag = {
          newLogFlag: newLogFlag,
          newMessageFlag: newMessageFlag
        }
      })
    },
    //批次下拉获取
    getBatchNameList(flag) {
      let data = {...this.currencyForm}
      data.reportCode = "clearStockBatchNameList"
      data.param = {
        completeFlag: flag || ''
      }
      axios.post(`/ec-pc-api/custom/reports/data/clearStockBatchNameList`,data).then(res => {
        if(res.code == 200) {
          this.batchNameList = res.data.list || []
        } 
      })
    }
  },
};
</script>

<style scoped lang="stylus">
.wrapper {
  margin: 5px;
  height: calc(100% - 10px);
  width: auto;
}

.search-wrapper {
  margin-bottom: 5px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 6px;

  >>> .el-divider {
    margin: 10px 0;
  }
}

 >>> .el-form-item {
    margin-bottom: 10px;
  }

>>> .el-form--inline .el-form-item:last-child {
  margin-right: 0;
}

.tabsBox {
  background: #FFFFFF;
  border-radius: 6px;
}

>>> .el-tabs__header {
  padding: 10px 10px 0 10px;
  position: relative;
  margin: 0;
}

>>> .el-tabs__nav-scroll {
  height: 40px;
}

>>> .el-tabs__nav {
  height: 40px;
}

>>> .el-tabs__item.is-active {
  border: 0;
  background-color: transparent;
}

>>> .el-link.el-link--primary {
  margin-right: 5px;
}

>>>.search-row .el-date-editor, >>>.search-row .el-select, >>>.search-row .el-input {
  width: 200px !important
}

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>

